import { gql } from '@apollo/client';

export const GET_PARTIAL_PICKUP_APPOINTMENTS = gql`
  query GetPartialPickupAppointments($filter: PickupProblemAppointmentFilterInput!) {
    getPartialPickupAppointments(filter: $filter) {
      content {
        appointmentId
        appointmentNumber
        taskNumber
        pickupSiteId
        pickupSiteName
        address
        partialPickupReason
        driverId
        driverName
        driverPhone
        arrivedAt
        expectedParcelCount
        expectedParcelUnit
        actualParcelCount
        actualParcelUnit
        repickupAppointmentNumber
        repickupScheduleType
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_PARTIAL_PICKUP_SUMMARY = gql`
  query GetPartialPickupSummary($hubId: Long!, $pickupDate: String!) {
    getPartialPickupSummary(hubId: $hubId, pickupDate: $pickupDate) {
      total
      countByTask {
        taskNumber
        count
      }
    }
  }
`;

export interface PartialPickupAppointmentItem {
  appointmentId?: number;
  appointmentNumber?: string;
  taskNumber?: string;
  pickupSiteId?: number;
  pickupSiteName?: string;
  address?: string;
  /** 1-部分货物未准备好，2-车辆装不下，3-其他 */
  partialPickupReason?: number;
  driverId?: number;
  driverName?: string;
  driverPhone?: string;
  arrivedAt?: string;
  expectedParcelCount?: number;
  expectedParcelUnit?: number;
  actualParcelCount?: number;
  actualParcelUnit?: number;
  /** 为空表示尚未安排二次上门 */
  repickupAppointmentNumber?: string;
  /** 1-当日上门，2-次日上门；未安排时为空 */
  repickupScheduleType?: number;
}

export interface PartialPickupAppointmentPage {
  content: PartialPickupAppointmentItem[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetPartialPickupAppointmentsResponse {
  getPartialPickupAppointments: PartialPickupAppointmentPage;
}

export interface GetPartialPickupSummaryResponse {
  getPartialPickupSummary: {
    total: number;
    countByTask: { taskNumber: string; count: number }[];
  };
}
